/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import {Button, Col, Panel, Row} from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, Form, propTypes, reduxForm } from 'redux-form';
import { isLocal } from '../../../../reducers/localId/localId';
import { remove as removeAction, save as saveAction } from '../../../../reducers/paymentTypes/paymentTypes.actions';
import SelectFormGroup from '../../../Forms/SelectFormGroup/SelectFormGroup';
import TTFormGroup from '../../../Forms/TTFormGroup/TTFormGroup';
import SpinnerButton from '../../../SpinnerButton/SpinnerButton';
import UnsavedChangesPrompt from '../../../UnsavedChangesPrompt/UnsavedChangesPrompt';
import './PaymentTypeForm.css';

export class PaymentTypeForm extends React.Component {
  constructor() {
    super();
    this.state = {
      showFields: false,
    };
  }

  render() {
    // eslint-disable-next-line object-curly-newline
    const {submitting, dirty, remove, save, initialize, handleSubmit, paymentType: {name, removing, id}} = this.props;
    return (
      <span>
        {dirty && <UnsavedChangesPrompt dirty/>}
        <Row style={{'margin-top': "-14px"}}>
          <Col md={1}><Button style={{'height': "14px", "padding": "5px 15px 20px 15px", "font-size": "14px"}} onClick={() => this.setState({showFields: !this.state.showFields})}>Edit</Button></Col>
          <Col md={11} style={{'font-size': "14px"}}>{name}</Col>
        </Row>
        <Panel>

        {(this.state.showFields || id.toString().includes('LOCAL')) &&
        <Form
          onSubmit={
            handleSubmit(values =>
              save(values, id)
                .then(paymentType => initialize(paymentType.response)))}
        >
          <Row>
            <Col md={4}>
              <Field
                component={TTFormGroup}
                name="name"
                label="Name"
                type="text"
                required
              />
            </Col>
            <Col md={4}>
              <Field
                component={SelectFormGroup}
                name="needs_vendor"
                label="Is a vendor needed?"
                options={[
                  {id: false, name: 'No'},
                  {id: true, name: 'Yes'},
                ]}
              />
            </Col>
            <Col md={4}>
              <Field
                component={SelectFormGroup}
                name="hide"
                label="Hide Payment Type?"
                options={[
                  {id: false, name: 'No'},
                  {id: true, name: 'Yes'},
                ]}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={2}>
              <SpinnerButton
                isLoading={submitting}
                type="submit"
                dirty={dirty}
              >
                {isLocal(id) ? 'Add' : 'Save'}
              </SpinnerButton>
            </Col>
            <Col xs={6} md={2}>
              <SpinnerButton
                isLoading={removing}
                onClick={() => remove(id)}
                bsStyle="danger"
              >
                Remove
              </SpinnerButton>
            </Col>
          </Row>
        </Form>
        }
        </Panel>
      </span>);
  }
}

PaymentTypeForm.propTypes = {
  ...propTypes,
  paymentType: PropTypes.shape({
    isRemoving: PropTypes.bool.isRequired,
  }).isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.paymentType,
  form: `paymentType${ownProps.paymentType.id}`,
});

export const mapDispatchToProps = dispatch => ({
  remove: id => dispatch(removeAction(id)),
  save: (values, id) => dispatch(saveAction({ ...values, id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ enableReinitialize: true })(PaymentTypeForm));



// WEBPACK FOOTER //
// ./src/components/Admin/PaymentTypes/PaymentTypeForm/PaymentTypeForm.jsx